import React from 'react';

function BrandCategoryLinks({block, getMessage, light = false}) {
  if (!Array.isArray(block.children) || block.children.length === 0) {
    return null;
  }

  const linkClassName = `inline-flex items-center rounded-[12px] p-[10px] text-[14px] leading-normal hover:bg-blue-primary phone:text-[13px] ${light
    ? 'bg-[#F3F3F3] text-black hover:text-white !transition-none'
    : 'bg-[#1A1A1A] text-white'}`;

  return (
    <div className={`flex flex-wrap gap-[7px] mt-[20px] ${light ? '' : 'mb-[25px]'}`}>
      {block.children.slice(0, 8).map(child => (
        <a key={`brand-category-child-${child.id}`}
          href={child.hideLink ? '#' : child.url}
          onClick={child.hideLink ? event => event.preventDefault() : undefined}
          className={linkClassName}>
          {child.title}
        </a>
      ))}

      {block.children.length > 8 && block.url && (
        <a href={block.url} className={linkClassName}>
          {getMessage('CATALOG_BRAND_CATEGORY_VIEW_ALL_SECTION_TITLE').replace('#SECTION_NAME#', block.title)}
        </a>
      )}
    </div>
  );
}

export default BrandCategoryLinks;